export default {
  data() {
    return {
      bundleAdded: false,
      bundleDiscount: 0,
      xSellBundleColorChosen:"White",
      blackSelected: false,
      whiteSelected:true,
      currentSlide: 0
    }
  },
  props:['title', 'bundle_title'],
  methods: {
    onSlide() {
      this.currentSlide = this.$refs.carousel.data.currentSlide.value
    },
    async addToCart(id) {
      let updates = {
        "id": id.toString(),
        "quantity": "1"
      }
      const response = await fetch(`/cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      });
      const data = await response.json();

      VWO.event("addToCartV3", {
        "context": "cross_sell",
        "price": (data.final_line_price / 100.0).toFixed(2)
      });

      return 
    },
    enhancedEcommerceXsellProductAdded(product) {
      window.dataLayer.push({ 'ecommerce': null });
      window.dataLayer.push({
          event: "add_to_cart",
          context:"basket cross-sell",
          ecommerce: {
            currency: "USD",
            atb_origin: 'cart',
            items: [
              {
                item_id: `${product.id}`,
                item_name: `${product.title}`,
                price: (product.altPrice) || (product.price / 100) ,
                quantity: 1
              }
            ]
          }
      })
    },
    async toBundle(colorChosen) {
      const blackClockVariantId = 32218222624815;
      const whiteClockVariantId = 32218222592047;
      const blackLampVariantId = 42813650731255;
      const whiteLampVariantId = 42649261080823;
      const blackClockInCart = store.getters.cart.items.find(i => i.variant_id == blackClockVariantId);
      const whiteClockInCart = store.getters.cart.items.find(i => i.variant_id == whiteClockVariantId);
      const blackLampInCart = store.getters.cart.items.find(i => i.variant_id == blackLampVariantId);
      const whiteLampInCart = store.getters.cart.items.find(i => i.variant_id == whiteLampVariantId);
      const nighstandConfig = {
        "White/White": 43549445259511,
        "White/Black": 43720366358775,
        "Black/White": 43549399711991,
        "Black/Black": 43720366391543
      };


      // select correct nighstand Bundle variant
      let nightstandVariantId = 43549445259511;

      (function getNightstandVariantId() {
        if (blackClockInCart) { 
          localStorage.setItem('replacedVariantId', blackClockVariantId)
          nightstandVariantId = nighstandConfig[`${colorChosen}/Black`];
        };
        if (whiteClockInCart) { 
          localStorage.setItem('replacedVariantId', whiteClockVariantId)
          nightstandVariantId = nighstandConfig[`${colorChosen}/White`];
        };
        if (blackLampInCart) { 
          localStorage.setItem('replacedVariantId', blackLampVariantId)
          nightstandVariantId = nighstandConfig[`Black/${colorChosen}`];
        };
        if (whiteLampInCart) {
          localStorage.setItem('replacedVariantId', whiteLampVariantId)
          nightstandVariantId = nighstandConfig[`White/${colorChosen}`];
        };
      })();

      // update cart by removing clock or lamp and adding bundle
      const payload = {	updates: {} }
      payload.updates[`${blackClockVariantId}`] = blackClockInCart?.quantity - 1 || 0;
      payload.updates[`${whiteClockVariantId}`] = whiteClockInCart?.quantity - 1 || 0;
      payload.updates[`${blackLampVariantId}`] = blackLampInCart?.quantity - 1 || 0;
      payload.updates[`${whiteLampVariantId}`] = whiteLampInCart?.quantity - 1 || 0;
      payload.updates[`${nightstandVariantId}`] = store.getters.cart.items.find(i => i.variant_id == nightstandVariantId)?.quantity + 1 || 1;
      const response = await fetch(`/cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const cart = await response.json();

      this.bundleAdded = true;

      setTimeout(()=> { this.bundleAdded = false;}, 10000)

    },
    chooseColor(color) {
      this.xSellBundleColorChosen = color;
      if (color === 'Black') {
        this.whiteSelected = false;
        this.blackSelected = true;
      } else {
        this.whiteSelected = true;
        this.blackSelected = false;
      }
    }

  },
  computed: {
    xsellProductsToShow () {
      return store.getters.xsellProductsToShow
    },
    showNightstandBundleInCarousel() {
      if (this.xsellProductsToShow.find( xSell => xSell.variants[0].id == 42649261080823 || xSell.variants[0].id == 32218222624815)) return true
    }
  },
  components: {
    Carousel: VueCarousel.Carousel,
    Slide: VueCarousel.Slide,
    Navigation: VueCarousel.Navigation
  },
  template:`
  <template v-if="xsellProductsToShow.length >= 1">
  <div class="x_sell_widget">
    <span :class="{ 'active_bundle': bundleAdded }" class="upgrade_bundle_note">Upgraded to bundle, saving you <span>20%</span> </span>
    <h1 v-if="showNightstandBundleInCarousel && currentSlide == 0" class="x_sell_header">{{this.bundle_title}}</h1>
    <h1 v-else class="x_sell_header">{{this.title}}</h1>
    <Carousel class="x_sell_carousel_bar" 
    :navigation-enabled="true"
    :min-swipe-distance="1"
    :touchDrag="true"
    ref="carousel"
    @click="onSlide()">
    <template #slides>
      <Slide class="x_sell_slide" v-for="(xSell,index) in xsellProductsToShow" :key="index">
      <div class="x_sell_image_wrapper" >
        <a :href="xSell.url" >
          <img  v-if="xSell.variants[0].id == 42649261080823" class="x_sell_image" :src="blackSelected ? xSell.variants[1].featured_image.src.replace('.jpg', '_200x.jpg') : xSell.variants[0].featured_image.src.replace('.jpg', '_200x.jpg')" alt="" >
          <img  v-else-if="xSell.variants[0].id == 32218222624815" class="x_sell_image" :src="blackSelected ? xSell.variants[0].featured_image.src.replace('.jpg', '_200x.jpg')  : xSell.variants[2].featured_image.src.replace('.jpg', '_200x.jpg') " alt="" >
          <img  v-else class="x_sell_image" :src="xSell.featured_image  + '&width=200'" alt="" >
        </a>
      </div>
        <h3 class="x_sell_title">{{xSell.title}}</h3>
        <p class="x_sell_description">{{xSell.shortDescription}}</p>
        <div class="xsell_price_wrapper">
          <span v-if="xSell.altPrice" class="x_sell_price alt">\${{xSell.altPrice}}</span>
          <span class="x_sell_price" :class="{ strike_through: xSell.altPrice }">\${{(xSell.price / 100).toFixed(2)}}</span>
        </div>
        <div v-if="xSell.variants[0].id == 32218222624815" class="bundle_select" id="selectBundle">
          <button :class="{selected: blackSelected}" class="color_choice_swatch black" @click="chooseColor('Black')"></button>
          <button :class="{selected: whiteSelected}" class="color_choice_swatch white clock" @click="chooseColor('White')"></button>
        </div>
        <div v-if="xSell.variants[0].id == 42649261080823" class="bundle_select" id="selectBundle">
          <button :class="{selected: blackSelected}" class="color_choice_swatch black" @click="chooseColor('Black')"></button>
          <button :class="{selected: whiteSelected}" class="color_choice_swatch white" @click="chooseColor('White')"></button>
        </div>
        <button v-if="xSell.variants[0].id == 32218222624815 || xSell.variants[0].id == 42649261080823" class="x_sell_atb_btn to-nightstand" @click="toBundle(xSellBundleColorChosen); enhancedEcommerceXsellProductAdded(xSell)">Upgrade</button>
        <button v-else class="x_sell_atb_btn nightstand" @click="addToCart(xSell.variants[0].id);  enhancedEcommerceXsellProductAdded(xSell)">Add To Cart</button>
      </Slide>
      </template >
      <template #addons="{ slidesCount, currentSlide }">
        <Navigation 
        v-if="slidesCount > 1" />
      </template>
    </Carousel>
  </div>
  </template>
  `
}

